import { EnvironmentProviders, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  IncludeBearerTokenCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  includeBearerTokenInterceptor,
  provideKeycloak,
  UserActivityService,
} from 'keycloak-angular';
import { environment } from '@environment/environment';
import { apiRequestPattern } from './api-request-pattern';
import { AuthService } from './auth.service';
import { initializeKeycloak } from './initialize-keycloak';
import { KeycloakAuthService } from './keycloak-auth.service';

export const authInterceptors = [includeBearerTokenInterceptor];

export const bearerTokenConditions = [
  createInterceptorCondition<IncludeBearerTokenCondition>({ urlPattern: apiRequestPattern(environment.apiURL) }),
];

export function provideAppAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideKeycloak({
      config: environment.keycloak,
      providers: [AutoRefreshTokenService, UserActivityService],
    }),
    provideAppInitializer(initializeKeycloak),
    { provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, useValue: bearerTokenConditions },
    { provide: AuthService, useClass: KeycloakAuthService },
  ]);
}
